import { useDisplaySettings } from '@src/providers/DisplaySettingsProvider';
import { getGroupedColumnColId, type MobileGroupCardRendererProps } from '@talos/kyoko';
import { MobileBlotterGroupCard, resolveGroupMetricCell } from '../MobileBlotterCardLayout';
import { getBalanceGroupValueMetric } from './mobileBalanceMetric';

export function MobileBalanceGroupCard({ node, renderCell }: MobileGroupCardRendererProps) {
  const { homeCurrency } = useDisplaySettings();
  const groupedColumnColId = getGroupedColumnColId(node);
  const groupMetricCell = resolveGroupMetricCell({
    colId: groupedColumnColId,
    fallbackLabel: node.key ?? '',
    renderCell,
  });
  const valueMetric = getBalanceGroupValueMetric(renderCell, homeCurrency);
  const warning = renderCell('reconWarning', { overrideColumnVisibility: true });

  return (
    <MobileBlotterGroupCard
      node={node}
      testId="mobile-balance-group-card"
      groupTestId="mobile-balance-group-card-group"
      groupMetricCell={groupMetricCell}
      warning={warning}
      warningTestId="mobile-balance-group-card-recon-warning"
      valueMetric={valueMetric}
      showExpandIndicator
    />
  );
}
